<template>
  <div class="addBrand">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>添加新品牌
        <!-- <div class="rutun">
          <div>
            <img src="../img/zuojaintou.png" alt>
          </div>
          <div @click="goback()">返回</div>
        </div>-->
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">新建品牌</div>
      </div>
      <div class="table">
        <el-form ref="form"  label-width="120px">
          <el-form-item label="品牌名称:">
            <el-input v-model="name" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="品牌logo:">
            <div class="grid-content input">
              <input
                class="ipt_fil"
                placeholder="选择上传文件"
                type="file"
                name="img"
                accept="img/png, img/jpeg, img/jpg"
                @change="getImage($event)"
              />
              <div class="notice">只能上传png/jpg格式文件,文件大小不能超过50KB</div>
            </div>
          </el-form-item>
          <el-form-item label="logo缩略图:">
            <div class="grid-content input">
              <input
                class="ipt_fil"
                placeholder="选择上传文件"
                type="file"
                name="img"
                accept="img/png, img/jpeg, img/jpg"
                @change="getImage1($event)"
              />
              <div class="notice">只能上传png/jpg格式文件,文件大小不能超过50KB</div>
            </div>
          </el-form-item>
          <el-form-item label="主要产品:">
            <el-input v-model="main_products" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="排序:">
            <el-input v-model="order_by" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="品牌国别:">
            <el-input v-model="state" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="品牌官网:">
            <el-input v-model="web" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="是否显示:">
            <el-switch v-model="value2" active-color="#0099FF" inactive-color="grey"></el-switch>
          </el-form-item>
          <el-form-item label="品牌介绍:">
            <wanged-itor @change_edit="change_edit"></wanged-itor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import WangedItor from "../components/wangeditor";
export default {
  components: {
    WangedItor
  },
  name: "addBrand",
  data() {
    return {
            serve: this.$store.state.serve,
      main_products: "",
      order_by: "",
      show: 1,
      name: "",
      info: "",
      img: null,
      img1: null,
      value1: true,
      value2: true,
      state: "",
      web: "",
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token")
    };
  },
  created() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "品牌管理";
  },
  mounted() {},
  methods: {
    change_edit(data) {
      this.info = data;
    },
    handimg(file, Editor, cursorLocation, resetUploader) {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      var formData = new FormData();
      formData.append("img", file);
      formData.append("username", this.username);
      formData.append("token", this.token);
      this.axios
        .post(
          this.serve+"/admin/edit_upload_img",
          formData,
          config
        )
        .then(res => {
          Editor.insertEmbed(cursorLocation, "image", res.data.data);
          resetUploader();
        });
    },
    goback(e) {
      this.$router.push({
        path: "./brand"
      });
    },
    getImage(e) {
      this.img = e.target.files[0];
    },
    getImage1(e) {
      this.img1 = e.target.files[0];
    },
    submit() {
      if (this.name == "") {
        this.$message.error("名字不能为空");
        return;
      }
      if (this.img == null) {
        this.$message.error("未选择品牌logo");
        return;
      }
      if (this.main_products == "") {
        this.$message.error("未填写主要产品");
        return;
      }
      if (this.order_by == "") {
        this.$message.error("未排序");
        return;
      }
      if (this.state == "") {
        this.$message.error("未填写所属国别");
        return;
      }
      if (this.web == "") {
        this.$message.error("未填写品牌官网");
        return;
      }

      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("logo", this.img);
      formData.append("logo_thumb", this.img1);
      formData.append("main_products", this.main_products);
      formData.append("show", this.show);
      formData.append("info", this.info);
      formData.append("order_by", this.order_by);
      formData.append("country", this.state);
      formData.append("website", this.web);
      formData.append("username", this.username);
      formData.append("token", this.token);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var that = this;
      this.axios
        .post(this.serve+"/admin/add_brand", formData)
        .then(function(res) {
          loading.close();
          if (res.data.status == "success") {
            that.$message({
              type: "success",
              message: "上传成功"
            });
            that.$router.push({ path: "/admin/brand" });
          } else if (res.data.status == "error") {
            that.$message.error(res.data.msg);
          }
        });
      // .catch(function(err) {
      //   alert("操作失败");
      // });
    }
  }
};
</script>
<style lang="scss">
.addBrand {
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;

  .form-title {
    line-height: 46px;
    height: 46px;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }

  .input {
    width: 100%;
  }
  textarea {
    height: 300px;
    width: 342px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    padding: 30px;
    background-color: #fff;
  }
  .row {
    margin-bottom: 20px;
  }
  .label {
    line-height: 40px;
  }
  .notice {
    font-size: 13px;
    color: #666;
    margin-top: 16px;
  }
  .button {
    border-radius: 5px;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 420px;
    top: 0;
    cursor: pointer;
  }
  .el-row {
    margin-bottom: 30px;
  }

  .switch {
    display: flex;
  }
  .el-switch {
    margin: 0 0 30px 26px;
  }
}
</style>